import React, { useState } from "react";
import { Row, Col, Dropdown, Breadcrumb } from "react-bootstrap";
import {
  FiHome,
  FiFileText,
  FiCalendar,
  FiChevronUp,
  FiChevronLeft,
  FiChevronRight,
  FiClock,
  FiTrendingUp,
} from "react-icons/fi";

// import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import AttendanceCard from "../../../components/Dashboard/employeedashboard/AttendanceCard";
import HoursStatCard from "../../../components/Dashboard/employeedashboard/HoursStatCard";
import WorkingHoursCard from "../../../components/Dashboard/employeedashboard/WorkingHoursCard";
import UserProfileCard from "../../../components/Dashboard/employeedashboard/UserProfileCard";
import LeaveStatsCard from "../../../components/Dashboard/employeedashboard/LeaveStatsCard";
import LeaveSummaryCard from "../../../components/Dashboard/employeedashboard/LeaveSummaryCard";
import EmployeeProjectsCard from "../../../components/Dashboard/employeedashboard/EmployeeProjectsCard";
import EmployeeTasksCard from "../../../components/Dashboard/employeedashboard/EmployeeTasksCard";
import PerformanceCard from "../../../components/Dashboard/employeedashboard/PerformanceCard";
import MySkillsCard from "../../../components/Dashboard/employeedashboard/MySkillsCard";
import TeamBirthdayCard from "../../../components/Dashboard/employeedashboard/TeamBirthdayCard";
import NotificationsCard from "../../../components/Dashboard/employeedashboard/NotificationsCard";
import TeamMembersCard from "../../../components/Dashboard/employeedashboard/TeamMembersCard";
import MeetingsScheduleCard from "../../../components/Dashboard/employeedashboard/MeetingsScheduleCard";
import { RiHome6Line } from "react-icons/ri";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default function EmployeeDashboardPage() {
  const [year, setYear] = useState(2025);
  const [selectedMonth, setSelectedMonth] = useState("Jan");

  return (
    <div
      style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }}
      className="page-breadcrumb mb-3"
    >
      <Row className="align-items-center justify-content-between">
        {/* LEFT SIDE */}
        <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Employee Dashboard
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Dashboard
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Employee Dashboard</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col md={6}>
          <div className="d-flex justify-content-md-end flex-wrap align-items-center">
            {/* EXPORT */}
            <Dropdown className="me-2 mb-2">
              <Dropdown.Toggle
                style={{ fontWeight: "500" }}
                variant="light"
                className="btn-white d-flex align-items-center export-btn "
              >
                <FiFileText className="me-1" />
                Export
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="p-2">
                <Dropdown.Item>Export as PDF</Dropdown.Item>

                <Dropdown.Item>Export as Excel</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* YEAR PICKER */}

            <Dropdown className="mb-2">
              <Dropdown.Toggle
                style={{ fontWeight: "500" }}
                variant="light"
                className="year-picker d-flex align-items-center "
              >
                <FiCalendar className="me-2 fw-bold" />
                {selectedMonth} {year}
              </Dropdown.Toggle>

              <Dropdown.Menu className="year-dropdown p-3">
                {/* YEAR HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <FiChevronLeft
                    style={{ cursor: "pointer" }}
                    onClick={() => setYear(year - 1)}
                  />

                  <strong>{year}</strong>

                  <FiChevronRight
                    style={{ cursor: "pointer" }}
                    onClick={() => setYear(year + 1)}
                  />
                </div>

                {/* MONTH GRID */}

                <div className="month-grid">
                  {months.map((m) => (
                    <div
                      key={m}
                      className={selectedMonth === m ? "month active" : "month"}
                      onClick={() => setSelectedMonth(m)}
                    >
                      {m}
                    </div>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>

            {/* COLLAPSE ICON */}

            {/* <div className="ms-2 mb-2">
              <button className="collapse-btn">
                <FiChevronUp />
              </button>
            </div> */}
          </div>
        </Col>

        <Row className="dashboard-row">
          <Col xxl={4}>
            <AttendanceCard />
          </Col>

          <Col xxl={8}>
            <Row>
              <Col className="task-card " xl={3} md={6}>
                <HoursStatCard
                  type="today"
                  value="8.36"
                  total="9"
                  title="Total Hours Today"
                  percent="5% This Week"
                  trend="up"
                />
              </Col>

              <Col className="task-card" xl={3} md={6}>
                <HoursStatCard
                  type="week"
                  value="10"
                  total="40"
                  title="Total Hours Week"
                  percent="7% Last Week"
                  trend="up"
                />
              </Col>

              <Col className="task-card" xl={3} md={6}>
                <HoursStatCard
                  type="month"
                  value="75"
                  total="98"
                  title="Total Hours Month"
                  percent="8% Last Month"
                  trend="down"
                />
              </Col>

              <Col className="task-card" xl={3} md={6}>
                <HoursStatCard
                  type="overtime"
                  value="16"
                  total="28"
                  title="Overtime this Month"
                  percent="6% Last Month"
                  trend="down"
                />
              </Col>

              <Col md={12}>
                <WorkingHoursCard />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xxl={4} xl={12} className="card-gap ">
            <UserProfileCard />
          </Col>

          <Col xxl={5} xl={12} className="card-gap">
            <LeaveStatsCard />
          </Col>

          <Col xxl={3} xl={12} className="card-gap">
            <LeaveSummaryCard />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xxl={6} xl={12} className="card-gap ">
            <EmployeeProjectsCard />
          </Col>

          <Col xxl={6} xl={12} className="card-gap">
            <EmployeeTasksCard />
          </Col>

          <style>{`

@media(max-width:1024px){
.card-gap{
margin-top:20px;
}
}

`}</style>
        </Row>

        <Row className="mt-4">
          <Col xxl={5} className="card-gap d-flex">
            <PerformanceCard />
          </Col>

          <Col xxl={4} xl={6} className="card-gap d-flex">
            <MySkillsCard />
          </Col>

          <Col xxl={3} xl={6} className="card-gap d-flex">
            <TeamBirthdayCard />
          </Col>
        </Row>
      </Row>

      <Row className="mt-4">
        <Col xl={4} lg={6} className="mb-3 responsive-space">
          <TeamMembersCard />
        </Col>

        <Col xl={4} lg={6} className="mb-3 responsive-space">
          <NotificationsCard />
        </Col>

        <Col xl={4} lg={12} className="mb-3 responsive-space">
          <MeetingsScheduleCard />
        </Col>
      </Row>

      <style>
        {`
          .page-breadcrumb h2{
font-size:24px;
color:#1e293b;
}



.breadcrumb{
font-size:14px;
}

.breadcrumb-item + .breadcrumb-item::before{
content: ">";
color:#6b7280;
}

.btn-white{
background:#fff;
border:1px solid #e5e7eb;
padding:8px 14px;
font-size:14px;
}

.export-btn{
border-radius:6px;
}

.year-picker{
border:1px solid #e5e7eb;
background:#fff;
padding:8px 14px;
border-radius:6px;
font-size:14px;
}

.year-dropdown{
width:260px;
border-radius:10px;
box-shadow:0 8px 20px rgba(0,0,0,0.08);
}

.month-grid{
display:grid;
grid-template-columns:repeat(4,1fr);
gap:10px;
}

.month{
padding:8px;
text-align:center;
border-radius:6px;
cursor:pointer;
font-size:14px;
}

.month:hover{
background:#ff6b1a;
}

.month.active{
background:#0d6efd;
color:white;
}

.collapse-btn{
border:1px solid #e5e7eb;
background:#fff;
padding:8px 10px;
border-radius:6px;
}
@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
.dashboard-card {
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.dashboard-card .card-header {
  background: #fff;
  border-bottom: 1px solid #eee;
  font-weight: 600;
}

/* Avatar */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

/* Member row */
.member-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.actions button {
  border: 1px solid #eee;
  background: #fff;
  margin-left: 5px;
  padding: 6px;
  border-radius: 6px;
}

/* Notifications */
.notification-row {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.file {
  font-size: 13px;
  color: #e74c3c;
}

.approve-btn {
  background: #ff6b2c;
  border: none;
}

/* Meetings */
.meeting-row {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.time {
  width: 80px;
  position: relative;
  font-size: 14px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  top: 5px;
}

.dot.orange { background: orange; }
.dot.blue { background: #3498db; }
.dot.yellow { background: #f1c40f; }
.dot.green { background: #2ecc71; }

.meeting-box {
  background: #f8f9fb;
  padding: 10px;
  border-radius: 8px;
  width: 100%;
}

/* Responsive Fix */
@media (max-width: 1024px) {
  .responsive-space {
    margin-top: 15px;
  }
}


      .toolbar{
        display:flex;
        justify-content:flex-end;
        align-items:center;
        gap:10px;
        flex-wrap:wrap;
      }

      /* COMMON BUTTON */
      .toolbar-btn{
        background:#f3f4f6 !important;
        border:1px solid #e5e7eb !important;
        border-radius:10px !important;
        padding:8px 14px !important;
        font-size:14px !important;
        display:flex;
        align-items:center;
        gap:6px;
        color:#111827;
        box-shadow:none !important;
      }

      .toolbar-btn:hover{
        background:#ffe7d6 !important;
        color:#f97316 !important;
        border-color:#f97316 !important;
      }

      .icon{
        font-size:16px;
      }

      /* DROPDOWN BOX */
      .dropdown-box{
        border-radius:10px;
        padding:6px;
        box-shadow:0 10px 20px rgba(0,0,0,0.08);
      }

      .dropdown-box .dropdown-item{
        border-radius:6px;
        font-size:14px;
      }

      .dropdown-box .dropdown-item:hover{
        background:#fff3ed;
        color:#f97316;
      }

      /* DATE DROPDOWN */
      .date-dropdown{
        padding:15px;
        border-radius:12px;
        width:220px;
        box-shadow:0 10px 25px rgba(0,0,0,0.1);
      }

      /* YEAR HEADER */
      .year-header{
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:10px;
        font-size:14px;
        color:#111827;
      }

      .year-header svg{
        cursor:pointer;
      }

      /* MONTH GRID */
      .month-grid{
        display:grid;
        grid-template-columns:repeat(4,1fr);
        gap:6px;
      }

      .month{
        text-align:center;
        padding:6px 0;
        border-radius:6px;
        font-size:13px;
        cursor:pointer;
      }

      .month:hover{
        background:#fff3ed;
        color:#f97316;
      }

      .month.active{
        background:#f97316;
        color:#fff;
      }

      /* COLLAPSE BUTTON */
      .collapse-btn{
        width:38px;
        height:38px;
        border-radius:10px;
        border:1px solid #e5e7eb;
        background:#f3f4f6;
        display:flex;
        align-items:center;
        justify-content:center;
      }

      .collapse-btn:hover{
        background:#ffe7d6;
        color:#f97316;
        border-color:#f97316;
      }

      /* RESPONSIVE */
      @media(max-width:1024px){
        .toolbar{
          margin-top:10px;
        }
      }

          `}
      </style>
    </div>
  );
}
